import { Component, OnInit, Input, Inject, LOCALE_ID} from '@angular/core';
import { PageService } from '../page.service';
import { PageItem } from '../page';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.css']
})
export class TextComponent implements OnInit {

  @Input() slug:string;
  pages:PageItem[];

  constructor(
    private pageService: PageService,
    @Inject(LOCALE_ID) protected localeId: string
  ) { }

  ngOnInit() {
    this.pageService.getPage(this.slug)
      .subscribe(data => {
        this.pages = data;
      });
  }

}
